import { List, ListItem, ListItemText } from '@mui/material'

const AddLogoSettingsInstruction = () => {
  return (
    <List sx={{ width: '100%' }}>
      <ListItem>
        <ListItemText>1. Supported file formats are jpg/jpeg/png</ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>2. File size should be less than 500KB</ListItemText>
      </ListItem>
      <ListItem>
        <ListItemText>
          3. Please don&apos;t upload nude/copyrighted/celebrity images
        </ListItemText>
      </ListItem>
    </List>
  )
}

export default AddLogoSettingsInstruction
